export default path => (path === "/es" || path.match(/\/es\//) ? "es" : "en");



// WEBPACK FOOTER //
// ./src/locales/fromPath.js